import { ActionTree } from 'vuex'
import { AttachmentState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<AttachmentState, RootState> = {
}
